/** Asteroids vector renderer (C). Draws game state without HUD text. */
import {
    WIDTH, HEIGHT, SHIP_RADIUS,
} from './asteroidsEngine';

export const COLORS = {
    background: '#000000',
    stars: '#3a3a4a',
    vector: '#f2f2f2',
    thrust: '#ff9f0a',
    bullet: '#ffffff',
};

const STARS = Array.from({ length: 36 }, (_, i) => ({
    x: (i * 67 + 19) % WIDTH,
    y: (i * 43 + 11) % HEIGHT,
}));

function drawAsteroid(ctx, asteroid) {
    ctx.save();
    ctx.translate(asteroid.x, asteroid.y);
    ctx.rotate(asteroid.rotation);
    ctx.beginPath();
    asteroid.points.forEach((scale, index) => {
        const angle = (index / asteroid.points.length) * Math.PI * 2;
        const x = Math.cos(angle) * asteroid.radius * scale;
        const y = Math.sin(angle) * asteroid.radius * scale;
        if (index === 0) {
            ctx.moveTo(x, y);
        } else {
            ctx.lineTo(x, y);
        }
    });
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}

function drawShip(ctx, state, frame) {
    const { ship } = state;
    if (state.status === 'playing' && ship.invulnerableMs > 0 && frame % 8 < 4) {
        return;
    }
    ctx.save();
    ctx.translate(ship.x, ship.y);
    ctx.rotate(ship.angle);
    ctx.beginPath();
    ctx.moveTo(SHIP_RADIUS + 2, 0);
    ctx.lineTo(-SHIP_RADIUS, -SHIP_RADIUS + 1);
    ctx.lineTo(-SHIP_RADIUS + 2, 0);
    ctx.lineTo(-SHIP_RADIUS, SHIP_RADIUS - 1);
    ctx.closePath();
    ctx.stroke();
    if (state.thrusting) {
        ctx.strokeStyle = COLORS.thrust;
        ctx.beginPath();
        ctx.moveTo(-SHIP_RADIUS + 1, -3);
        ctx.lineTo(-SHIP_RADIUS - 6 - (frame % 3), 0);
        ctx.lineTo(-SHIP_RADIUS + 1, 3);
        ctx.stroke();
    }
    ctx.restore();
}

export function render(ctx, state, frame = 0) {
    ctx.fillStyle = COLORS.background;
    ctx.fillRect(0, 0, WIDTH, HEIGHT);
    ctx.fillStyle = COLORS.stars;
    STARS.forEach(star => ctx.fillRect(star.x, star.y, 1, 1));

    ctx.strokeStyle = COLORS.vector;
    ctx.lineWidth = 1;
    state.asteroids.forEach(asteroid => drawAsteroid(ctx, asteroid));
    drawShip(ctx, state, frame);

    ctx.fillStyle = COLORS.bullet;
    state.bullets.forEach(bullet => ctx.fillRect(Math.round(bullet.x), Math.round(bullet.y), 2, 2));
}
